import { path } from 'ramda';

import { getUserFundraiser } from 'src/redux/fundraisers/fundraiser.selector';
import { getHandler } from 'src/utils/fetchHandler';

export const GET_TEAM = 'GET_TEAM/TEAM/@WISELY/WEB';
export const FETCH_TEAM_SUCCEEDED = 'FETCH_TEAM_SUCCEEDED/TEAM/@WISELY/WEB';
export const FETCH_TEAM_FAILED = 'FETCH_TEAM_FAILED/TEAM/@WISELY/WEB';

export const getTeam = () => ({
	type: GET_TEAM,
});

export const fetchTeamSucceeded = payload => ({
	type: FETCH_TEAM_SUCCEEDED,
	payload,
});

export const fetchTeamFailed = payload => ({
	type: FETCH_TEAM_FAILED,
	payload,
});

export const fetchTeam = () => {
	return async (dispatch, getState) => {
		const id = path(['teams', '0', 'team'], getUserFundraiser(getState())) || 'default';
		dispatch(getTeam());

		const apiPath = `v2/teams/${id}`;

		return getHandler(apiPath)
			.then(json => dispatch(fetchTeamSucceeded(json)))
			.catch(error => {
				console.error('fetchTeam error', error);
				dispatch(fetchTeamFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/teams/team.action.js